export enum TaskStatuses {
  COMPLETED = 'Completed',
  TO_DO = 'To_Do',
  NOT_APPLICABLE = 'Not_Applicable',
}

export type TaskStatus = typeof TaskStatuses[keyof typeof TaskStatuses];

type TaskOperation = {
  isActionInProgress: boolean;
  setIsActionInProgress: (inProgress: boolean) => void;
};

export interface ITask extends TaskOperation {
  id: number;
  getLabel: () => string;
  equalsStatus: (status: TaskStatus) => boolean;
  getStatusLabel: () => string;
  getStatus: () => TaskStatus;
  setStatus: (status: TaskStatus) => void;
}

class Task implements ITask {
  public isActionInProgress = false;

  constructor(public id: number, private description: string, private status: TaskStatus) {}

  getStatusLabel(): string {
    if (this.equalsStatus(TaskStatuses.COMPLETED)) {
      return 'Completed';
    }
    if (this.equalsStatus(TaskStatuses.NOT_APPLICABLE)) {
      return 'Not applicable';
    }

    return '';
  }

  getLabel() {
    return this.description;
  }

  equalsStatus(status: TaskStatus) {
    return this.status === status;
  }

  getStatus(): TaskStatus {
    return this.status;
  }

  setStatus(status: TaskStatus): void {
    this.status = status;
  }

  setIsActionInProgress(inProgress: boolean): void {
    this.isActionInProgress = inProgress;
  }
}

export default Task;
